module.exports = __webpack_public_path__ + "static/media/06_1.ad00c869.png";